module.exports = __webpack_public_path__ + "img/columbus-logo.afc1a0a8.svg";